import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 0rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: rgb(255, 255, 255);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2.1rem;
  }
`;

const Emphasis = styled.span`
  color: #007acc;
  font-weight: bold;
`;

const SubTitle = styled.h2`
  font-size: 2rem;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  color: rgb(255, 255, 255);

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Text = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: rgb(235, 232, 232);

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const TermsOfService = () => {
  return (
    <Container>
      <Title>
        Terms of <Emphasis>Service</Emphasis>
      </Title>

      <Text>
        These <Emphasis>Terms of Service</Emphasis> govern your use of our website and services. By accessing or using our service,
        you agree to be bound by these terms.
      </Text>

      <SubTitle>1. Use of Site</SubTitle>
      <Text>
        You must be at least 13 years old to use this site. Do not misuse the content or services provided.
        Any unauthorized use may result in restricted access.
      </Text>

      <SubTitle>2. Intellectual Property</SubTitle>
      <Text>
        All content, including text, graphics, and code, is the property of the site owner. You may not copy,
        distribute, or use it without prior written permission.
      </Text>

      <SubTitle>3. Termination</SubTitle>
      <Text>
        We reserve the right to suspend or terminate your access to the service at any time, with or without
        notice, for conduct that we believe violates these terms or is harmful to other users.
      </Text>
    </Container>
  );
};

export default TermsOfService;
